// Supabase Auth in the browser: email and password. The web never reads
// tables through the Data API; it only forwards the session's access token.
import { createClient } from '@supabase/supabase-js';
import type { AuthPort } from './port.js';

export interface SupabaseAuthOptions {
  url: string;
  anonKey: string;
}

export function createSupabaseAuth(options: SupabaseAuthOptions): AuthPort {
  const client = createClient(options.url, options.anonKey, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
  });

  return {
    async getAccessToken() {
      const { data } = await client.auth.getSession();
      return data.session?.access_token ?? null;
    },

    async signInWithPassword(email, password) {
      const { error } = await client.auth.signInWithPassword({ email, password });
      if (error) throw error;
    },

    async signOut() {
      await client.auth.signOut();
    },

    onChange(listener) {
      void client.auth.getSession().then(({ data }) => listener(data.session !== null));
      const { data } = client.auth.onAuthStateChange((_event, session) => listener(session !== null));
      return () => data.subscription.unsubscribe();
    },
  };
}
